module.exports = __webpack_public_path__ + "static/img/Inspection31.b251c6a8.png";